var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-form", { attrs: { rules: _vm.validateRules } }, [
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-label" }, [
          _c("label", { class: _vm.requiredFlag ? "required" : "" }, [
            _vm._v("预计到货日期")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c("el-date-picker", {
              staticClass: "width-1-5x",
              attrs: {
                "picker-options": _vm.pickerOptions0,
                type: "date",
                placeholder: "选择日期"
              },
              model: {
                value: _vm.logisCom.expectArriveDate,
                callback: function($$v) {
                  _vm.$set(_vm.logisCom, "expectArriveDate", $$v)
                },
                expression: "logisCom.expectArriveDate "
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-label " }, [
          _c("label", { staticClass: "required" }, [_vm._v("发货人")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "senderContactName" } },
              [
                _c("el-input", {
                  staticClass: "width-1-5x",
                  model: {
                    value: _vm.logisCom.senderContactName,
                    callback: function($$v) {
                      _vm.$set(_vm.logisCom, "senderContactName", $$v)
                    },
                    expression: "logisCom.senderContactName"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-label " }, [
          _c("label", { staticClass: "required" }, [_vm._v("发货人联系方式")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "senderContactTel" } },
              [
                _c("el-input", {
                  staticClass: "width-1-5x",
                  model: {
                    value: _vm.logisCom.senderContactTel,
                    callback: function($$v) {
                      _vm.$set(_vm.logisCom, "senderContactTel", $$v)
                    },
                    expression: "logisCom.senderContactTel"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-label" }, [
          _c("label", { class: _vm.requiredFlag ? "required" : "" }, [
            _vm._v("物流公司名称")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c("el-input", {
              staticClass: "width-1-5x bottom-line",
              attrs: { disabled: "", type: "text" },
              model: {
                value: _vm.logisCom.logisComName,
                callback: function($$v) {
                  _vm.$set(_vm.logisCom, "logisComName", $$v)
                },
                expression: "logisCom.logisComName"
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
              attrs: { title: "选择" },
              on: {
                click: function($event) {
                  _vm.selectLogisCom()
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-label" }, [
          _c("label", { class: _vm.requiredFlag ? "required" : "" }, [
            _vm._v("物流公司代码")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c("el-input", {
              staticClass: "width-1-5x bottom-line",
              attrs: { disabled: "", type: "text" },
              model: {
                value: _vm.logisCom.logisComCode,
                callback: function($$v) {
                  _vm.$set(_vm.logisCom, "logisComCode", $$v)
                },
                expression: "logisCom.logisComCode"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-label" }, [
          _c("label", { class: _vm.requiredFlag ? "required" : "" }, [
            _vm._v("物流单号")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value " },
          [
            _c("el-input", {
              staticClass: "width-1-5x",
              attrs: { type: "text" },
              model: {
                value: _vm.logisCom.logisExpNo,
                callback: function($$v) {
                  _vm.$set(_vm.logisCom, "logisExpNo", $$v)
                },
                expression: "logisCom.logisExpNo"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5a50e76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5a50e76","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/merchtLogis/MerchtLogisComSet.vue
// module id = 2687
// module chunks = 0